/**
 * VILA ALTA — vilarejo mediterrâneo em encosta, fim de tarde.
 *
 * ESQUELETO MÍNIMO (primeira etapa): chão, muro de perímetro, o patamar alto,
 * a escadaria principal e três volumes. Só existe para provar que `?map=vila`
 * carrega e que o dump responde antes de qualquer enfeite entrar.
 *
 * Convenção: +X leste, +Z sul, Y para cima. Uma unidade = um metro.
 * O contrato completo está no topo de src/world/MapKit.js.
 */

// Cotas que aparecem em mais de um lugar.
const ALTO = 2.5;        // piso do patamar alto (<= 2.6 do NavField, <= 2.7 do teste de IA)
const BORDA = 2.0;       // z da face do muro de arrimo: ao norte dele o terreno é alto

export default {
  id: 'vila',
  nome: 'Vila Alta',
  regiao: 'Vilarejo em encosta',
  seed: 20260815,

  bounds: { min: [-36, -1, -36], max: [36, 22, 36] },

  player: { spawn: [0, 1.68, 28.0], yaw: 0 },

  spawns: [
    [-14.0, 0, 12.0, 1.4, 'enemy', true],
    [14.0, 0, 12.0, 4.8, 'enemy', true],
    [0, ALTO, -6.0, 3.1, 'enemy', true],
    [-18.0, ALTO, -14.0, 2.0, 'enemy', true],
    [18.0, ALTO, -14.0, 4.2, 'enemy', true],
    [-8.0, 0, 22.0, 0.4, 'patrol', true],
    [8.0, 0, 22.0, 3.0, 'patrol', true],
    [-20.0, 0, 6.0, 1.2, 'patrol', true],
    [20.0, 0, 6.0, 4.6, 'patrol', true],
    [0, ALTO, -20.0, 3.0, 'patrol', true],
  ],

  luzes: [
    [0, 3.1, 14.0, 0xffd6a0, 20, 14, false],
  ],
  piscam: [],

  ambiente: {
    sol: { azimute: 250, elevacao: 26, intensidade: 9.5, cor: 0xffe4bc },
    ceu: { zenite: 0x5a8ec6, horizonte: 0xe2d0ac, chao: 0x7a6448, corSol: 0xffe8c4, turbidez: 0.6, neblina: 0.4 },
    hemi: { ceu: 0xa2bfe0, chao: 0x8a6f4e, intensidade: 3.6 },
    fog: { cor: 0xd6c3a2, densidade: 0.004 },
    paleta: {
      terreno: 'sand', piso: 'tile', parede: 'plaster', estrutura: 'concrete',
      metal: 'metalPainted', ferro: 'gunMetal', madeira: 'woodPlank',
      ferrugem: 'rust', pano: 'fabric', telha: 'tile',
    },
  },

  build(kit, ctx) {
    const rng = ctx.rng;
    kit.groundPlane('sand', { size: 180, repeat: 45, name: 'ground' });

    // patamar alto: uma laje só, do muro de arrimo para o norte
    kit.slab('sand', -35, 35, -35, BORDA, ALTO, 1.2, [], { tint: [0.98, 0.94, 0.86] });

    // muro de perímetro
    for (const [ax, az, bx, bz] of [
      [-35, -35, 35, -35], [-35, 35, 35, 35], [-35, -35, -35, 35], [35, -35, 35, 35],
    ]) {
      kit.wall('concrete', ax, az, bx, bz, 0, 4.0, 0.7, { tint: [0.94, 0.9, 0.82] });
    }

    // escadaria principal: praça -> patamar alto
    kit.stairs('concrete', 1.0, 7.5, 0, -1, 10, 0.25, 0.55, 4.0, 0, { rail: 'both' });

    // três volumes
    kit.building({ x0: -22, x1: -12, z0: 8, z1: 16, floors: 1, tint: [1.0, 0.98, 0.94] });
    kit.building({ x0: 12, x1: 22, z0: 8, z1: 16, floors: 1, tint: [1.0, 0.98, 0.94] });
    kit.building({ x0: -6, x1: 6, z0: -14, z1: -6, base: ALTO, floors: 1, tint: [1.0, 0.98, 0.94] });

    kit.coverBlock(0, 14, 2.4, 1.15, 2.4);
    if (rng() < 2) kit.crates([[-6, 20], [6, 20]]);
  },
};
